/**
 * Opens a browser print dialog for a bill receipt payload from PrintService.
 * @param {object} printJob
 * @param {string} [documentTitle]
 */
export function printBillReceipt(printJob, documentTitle) {
  if (!printJob?.html) return false;

  const paperMm = printJob.paper_width_mm || 80;
  const isPaper = paperMm >= 148;

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = isPaper ? "100%" : `${paperMm}mm`;
  iframe.style.maxWidth = "100%";
  iframe.style.height = "0";
  iframe.style.border = "0";
  iframe.setAttribute("aria-hidden", "true");
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow?.document;
  if (!doc) {
    document.body.removeChild(iframe);
    return false;
  }

  let didPrint = false;
  const cleanup = () => {
    setTimeout(() => {
      if (iframe.parentNode) document.body.removeChild(iframe);
    }, 500);
  };

  const triggerPrint = () => {
    if (didPrint) return;
    didPrint = true;
    iframe.contentWindow?.focus();
    iframe.contentWindow?.print();
    cleanup();
  };

  iframe.onload = triggerPrint;

  doc.open();
  doc.write(printJob.html.replace('onload="window.print()"', ""));
  if (documentTitle) {
    doc.title = documentTitle;
  }
  doc.close();

  if (iframe.contentWindow?.document?.readyState === "complete") {
    triggerPrint();
  }

  return true;
}
